/**
 * 通常の入力欄
 */

import React, { ChangeEvent, forwardRef } from 'react';

type InputMode =
  | 'text'
  | 'none'
  | 'search'
  | 'email'
  | 'tel'
  | 'url'
  | 'numeric'
  | 'decimal'
  | undefined;

type Props = {
  value?: string;
  type?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  maxLength?: number;
  size?: 's' | 'm';
  error?: boolean;
  autoComplete?: string;
  inputMode?: InputMode;
};

const Input = forwardRef<HTMLInputElement, Props>(
  (
    {
      value,
      type = 'text',
      onChange,
      placeholder = '',
      disabled = false,
      onKeyDown,
      maxLength,
      size = 's',
      error = false,
      autoComplete = 'on',
      inputMode = undefined,
    },
    ref,
  ) => {
    return (
      <input
        ref={ref}
        className={`w-full rounded-[2px] border border-solid border-gray-250 px-[16px] text-base outline-none lg:text-base 
        ${size === 's' ? 'py-[10px] lg:py-[8px]' : ''}
        ${size === 'm' ? 'py-[14px] lg:py-[12px]' : ''}
        ${error ? 'border-warning-500 bg-warning-200/70' : ''}
      `}
        type={type}
        {...(value !== undefined ? { value: value || '' } : {})}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        onKeyDown={onKeyDown}
        maxLength={maxLength}
        autoComplete={autoComplete}
        inputMode={inputMode}
      />
    );
  },
);

Input.displayName = 'Input';

export default Input;
